module.exports = __webpack_public_path__ + "img/3f_r_excel.3b60890f.png";